import React, { useState } from 'react';
import './ZoomImage.css';

const ZoomImage = ({ src, alt }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseEnter = () => {
    setIsZoomed(true);
  };

  const handleMouseMove = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setOffset({ x, y });
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
  };

  return (
    <div 
      className={`zoom-image-container ${isZoomed ? 'zoomed' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <img src={src} alt={alt} className='zoom-image' />
      {isZoomed && (
        <div 
          className='zoom-image-lens'
          style={{ backgroundImage: `url(${src})`, backgroundPosition: `${offset.x}% ${offset.y}%` }}
        />
      )}
    </div>
  );
};

export default ZoomImage;